/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../Fixes';
import Builder from '../../../../../../Builder';
import './flag_groups';
import '../../message/context';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "flags": {
                "nested": {
                  "v2": {
                    "nested": {
                      "message": {
                        "nested": {
                          "DefaultUserContextType": {
                            "values": {
                              "MERCHANT": 0,
                              "UNIT": 1,
                              "PERSON": 2
                            }
                          },
                          "SquareTokenType": {
                            "values": {
                              "MERCHANT_TOKEN": 0,
                              "UNIT_TOKEN": 1,
                              "PERSON_TOKEN": 2
                            }
                          },
                          "MultipassContextFlags": {
                            "fields": {
                              "defaultUserContext": {
                                "type": ".squareup.feature.relay.flags.v2.message.DefaultUserContextType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "flagGroups": {
                                "type": ".squareup.feature.relay.flags.v2.message.FlagGroups",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "MultipassGroup": {
                            "fields": {
                              "multipassContextFlags": {
                                "type": ".squareup.feature.relay.flags.v2.message.MultipassContextFlags",
                                "id": 1,
                                "rule": "repeated"
                              },
                              "tokensToExtract": {
                                "type": ".squareup.feature.relay.flags.v2.message.SquareTokenType",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "squareMobileDevice": {
                                "type": ".squareup.feature.relay.flags.message.SquareMobileDevice",
                                "id": 2
                              },
                              "squareBrowser": {
                                "type": ".squareup.feature.relay.flags.message.SquareBrowser",
                                "id": 4
                              },
                              "browser": {
                                "type": ".squareup.feature.relay.flags.message.Browser",
                                "id": 5
                              }
                            },
                            "nested": {
                              "device_context": {
                                "oneof": [
                                  "squareMobileDevice",
                                  "squareBrowser",
                                  "browser"
                                ]
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.DefaultUserContextType && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.SquareTokenType && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.MultipassContextFlags && !$root.nested?.squareup?.nested?.feature?.nested?.relay?.nested?.flags?.nested?.v2?.nested?.message?.nested?.MultipassGroup) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE DefaultUserContextType @ squareup/feature/relay/flags/v2/message/multipass.proto at 11:1
 */
export const DefaultUserContextType = $root.lookupEnum('squareup.feature.relay.flags.v2.message.DefaultUserContextType').values;
/**
 * SOURCE SquareTokenType @ squareup/feature/relay/flags/v2/message/multipass.proto at 17:1
 */
export const SquareTokenType = $root.lookupEnum('squareup.feature.relay.flags.v2.message.SquareTokenType').values;
/**
 * SOURCE MultipassContextFlags @ squareup/feature/relay/flags/v2/message/multipass.proto at 23:1
 */
export const MultipassContextFlags = $root.lookupType('squareup.feature.relay.flags.v2.message.MultipassContextFlags');
fixType(MultipassContextFlags);
Builder.createAndAttachToType(MultipassContextFlags);
/**
 * SOURCE MultipassGroup @ squareup/feature/relay/flags/v2/message/multipass.proto at 28:1
 */
export const MultipassGroup = $root.lookupType('squareup.feature.relay.flags.v2.message.MultipassGroup');
fixType(MultipassGroup);
Builder.createAndAttachToType(MultipassGroup);
